import { queryClient } from '@/lib/queryClient';
import { CLAVES_DE_LA_PLATA } from '@/lib/dropshipping/laPlataCambio';

/**
 * Olvida todo lo que este cacheado sobre listas de pedidos.
 *
 * 🚨 DE DONDE SALE. El founder: «cuando se elimina un pedido ya no deberia aparecer en la lista,
 *    pero si no refresco la pagina sigue apareciendo». Tenia razon, y el borrado funcionaba: lo
 *    que fallaba era el AVISO.
 *
 *    Habia tres formas de eliminar un pedido y cada una se acordaba —o no— de refrescar por su
 *    cuenta: la lista llamaba a `reload()`, el detalle solo NAVEGABA de vuelta a la lista, y el
 *    panel de Chats solo cerraba el editor. Los dos ultimos dejaban la lista servida desde cache
 *    con el pedido que ya no existe; refrescar la pagina la tiraba, y por eso «se arreglaba».
 *
 * ⭐ VIVE EN LA CAPA DE DATOS, NO EN CADA PANTALLA. Quien borra no tiene que acordarse de nada:
 *    borrar YA implica olvidar. Una regla que hay que recordar en tres lugares es una regla que
 *    se va a olvidar en el cuarto.
 *
 * 🪤 SE INVALIDA POR RAIZ, no la consulta exacta. Un pedido aparece en varias colas y en varias
 *    paginas de cada una: refrescar solo la que se esta mirando deja el fantasma en las demas,
 *    listo para reaparecer al cambiar de pestaña.
 *
 * 🪤 Y ALCANZA A LOS KPIs Y AL TOTAL: si «Presupuestos 2.054» no cambia despues de borrar uno, el
 *    numero de arriba contradice a la lista de abajo — que es peor que no mostrarlo.
 */
export function olvidarListasDePedidos(): void {
  for (const raiz of ['ops-orders', 'ops-orders-total', 'ops-kpis']) {
    void queryClient.invalidateQueries({ queryKey: [raiz] });
  }
  olvidarLoDeLaBilleteraDrop();
}

/**
 * Lo que hay que olvidar cuando se MOVIÓ PLATA de Smarty Drop.
 *
 * ⭐ UNA REGLA, DOS MOMENTOS. La plata del revendedor se mueve al confirmar una venta (el encargo se
 *    paga solo) y al deshacerla (el saldo vuelve). Las dos veces cambian las mismas cuatro
 *    pantallas, así que la lista vive acá y no repetida en cada camino: el tercero que aparezca la
 *    llama y nace completo.
 *
 * 🚨 DE DÓNDE SALE. El founder (21-sep-2026) borró S-00009, creó S-00010 y vio «el mismo saldo». El
 *    reintegro (+22) nunca se mostró porque nadie avisó a la billetera, y el consumo de la venta
 *    nueva (−22) la dejó donde estaba: la plata se movió dos veces y la pantalla ninguna.
 *
 * 🪤 Para una tienda que no revende, estas consultas no están activas: invalidarlas no cuesta nada.
 */
export function olvidarLoDeLaBilleteraDrop(): void {
  // Borrar una venta de Drop devuelve plata: la familia entera (auditoría 26-sep).
  for (const raiz of [...CLAVES_DE_LA_PLATA]) {
    void queryClient.invalidateQueries({ queryKey: [raiz] });
  }
}
